module.exports = __webpack_public_path__ + "img/caselist22.85cda208.jpg";